/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type MODERATION_MODE = "POST" | "PRE" | "%future added value";
export type CreateCommentMutation_story = {
    readonly settings: {
        readonly moderation: MODERATION_MODE;
    };
    readonly " $refType": "CreateCommentMutation_story";
};
export type CreateCommentMutation_story$data = CreateCommentMutation_story;
export type CreateCommentMutation_story$key = {
    readonly " $data"?: CreateCommentMutation_story$data;
    readonly " $fragmentRefs": FragmentRefs<"CreateCommentMutation_story">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateCommentMutation_story",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "StorySettings",
            "kind": "LinkedField",
            "name": "settings",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "moderation",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "Story",
    "abstractKey": null
} as any);
(node as any).hash = 'b04ff2a32d30fe35476366243e5ed0c5';
export default node;
